module.exports = __webpack_public_path__ + "static/img/70bde8d9e212c7731d05f0347bf71507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/config_tool.png
// module id = pMjj
// module chunks = 1